
export class ContentUpdateStatus
{
    public IsSuccess = false;
    public ContentSize = -1;
    public ErrorMessage = "";
    public BackupDirectory?: string;

    constructor(isSuccess: boolean, contentSize: number, errorMessage: string, backupDirectory?: string)
    {
        this.IsSuccess = isSuccess;
        this.ContentSize = contentSize;
        this.ErrorMessage = errorMessage;
        this.BackupDirectory = backupDirectory;
    }

    public static Success(contentSize: number, backupDirectory?: string): ContentUpdateStatus
    {
        return new ContentUpdateStatus(true, contentSize, "", backupDirectory);
    }

    public static Error(errorMessage: string): ContentUpdateStatus
    {
        return new ContentUpdateStatus(false, -1, errorMessage);
    }
}
